import { IconBuildingsFilled } from '@zillow/constellation-icons';
import {
  ADVERTISED_PROPERTY_MARKET_MAP_DOT_COLOR,
  CLAIMED_PROPERTY_MARKET_MAP_DOT_COLOR,
  DARK_ICON_COLOR,
} from '../../../SharedComponents/Map/Dots/Dots.consts';
import { useMainLayout } from '../../../layouts/MainPageLayout/MainLayoutContext';
import { DisplayingRegionLevel } from '../../../../types/DisplayingRegionLevel';
import { displayingModesWithPropertyMarkers } from './OverviewMap.hooks';
import { MapControls as SharedMapControls } from '../../../SharedComponents/Map/MapControls';
import type { PortfolioAnalyticsPropertyResponseDto } from '@zg-rentals/ts-customer-analytics-client';

export const OverviewMapControls = ({
  showRegularProperties,
  showClaimedProperties,
  setShowRegularProperties,
  setShowClaimedProperties,
  advertisedProperties,
  claimedProperties,
}: {
  showRegularProperties: boolean;
  showClaimedProperties: boolean;
  setShowRegularProperties: (showRegularProperties: boolean) => void;
  setShowClaimedProperties: (showClaimedProperties: boolean) => void;
  advertisedProperties: Array<PortfolioAnalyticsPropertyResponseDto>;
  claimedProperties: Array<PortfolioAnalyticsPropertyResponseDto>;
}) => {
  const { selectedRegionId, selectedDisplayingRegionLevel, displayMode } = useMainLayout();

  if (selectedRegionId && selectedDisplayingRegionLevel === DisplayingRegionLevel.STATE) return null;
  if (!displayingModesWithPropertyMarkers.includes(displayMode)) return null;

  const sections = [
    {
      title: "Show your portfolio's",
      controls: [
        {
          backgroundColor: ADVERTISED_PROPERTY_MARKET_MAP_DOT_COLOR,
          icon: <IconBuildingsFilled />,
          title: 'Advertised properties',
          checked: showRegularProperties,
          onChange: () => setShowRegularProperties(!showRegularProperties),
          items: advertisedProperties,
        },
        {
          backgroundColor: CLAIMED_PROPERTY_MARKET_MAP_DOT_COLOR,
          iconColor: DARK_ICON_COLOR,
          icon: <IconBuildingsFilled />,
          title: 'Claimed properties',
          checked: showClaimedProperties,
          onChange: () => setShowClaimedProperties(!showClaimedProperties),
          items: claimedProperties,
        },
      ],
    },
  ];

  return <SharedMapControls sections={sections} />;
};
